<script>
  export let color="white";
</script>

<svg width="15px" height="15px" style="fill:{color}" version="1.1" viewBox="20 0 100 100" xmlns="http://www.w3.org/2000/svg">
  <path d="m70.832 12.5h-41.664v8.332h7.8125l-2.6055 29.168h-1.043c-4.6016 0-8.332 3.7305-8.332 8.332v4.168h20.832v20.832l4.168 4.168 4.168-4.168v-20.832h20.832v-4.168c0-2.207-0.87891-4.3281-2.4414-5.8906s-3.6836-2.4414-5.8906-2.4414h-1.043l-2.6055-29.168h7.8125z"/>
</svg>
